<div class="checkbox">
  <label *ngIf="props.label" class="checkbox__label">
    {{ props.label | htmlDecode }}
    <span class="required-color" *ngIf="props.required">*</span>
  </label>

  <ng-container *ngFor="let option of getOptions(); let i = index">
    <sl-checkbox
      class="checkbox__element"
      [id]="id + '_' + i" 
      [formlyAttributes]="field"
      [shoelaceReadonly]="props.readonly"
      [attr.disabled]="isDisabled(option)"
      [checked]="option.selected"
      (sl-change)="onChange(option.value, $event)">
      {{ option.label }}
    </sl-checkbox>
  </ng-container>
</div>

